import { turnToArrForThree } from "utils/turnToArrForThree";

export const makeCloudSmokeObj = (position: number[], scale: number, opacity: number) => {
    return { position, scale: turnToArrForThree(scale), opacity };
};
